import { render, staticRenderFns } from "./FormInputPercentageWidget.vue?vue&type=template&id=cdd0e4f8&"
import script from "./FormInputPercentageWidget.vue?vue&type=script&lang=js&"
export * from "./FormInputPercentageWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports